import { Platform } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import { B5, SH3 } from '@zet/design-system/typography'
import { B18, R14 } from '@zet/integration-flow/components/typography'
import useGetAgentDetailsAndTheme from '@zet/zet-pro-quick-journey/hooks/useGetAgentDetailsAndTheme'

type BenefitsType = {
  heading: string
  content: string[]
}

export const Benefits = ({ content, heading }: BenefitsType) => {
  const { isJfsFlow } = useGetAgentDetailsAndTheme()
  return (
    <Stack
      className={
        Platform.OS === 'web'
          ? 'bg-neutral-white100 mb-2 px-3 py-3'
          : 'bg-neutral-white100 mb-2 px-3 py-[12]'
      }
    >
      {isJfsFlow ? (
        <B18 className="mb-2">{heading}</B18>
      ) : (
        <SH3 className="mb-2">{heading}</SH3>
      )}
      {content?.map((value, index) => (
        <Stack key={index}>
          {isJfsFlow ? (
            <R14 className="mt-1 text-justify text-[#24262BA6]">
              {'• ' + value}
            </R14>
          ) : (
            <B5 className="text-grays-50 mt-1 text-justify"> {value}</B5>
          )}
        </Stack>
      ))}
    </Stack>
  )
}
